import { SyntheticEvent, forwardRef, useEffect, useImperativeHandle, useState } from "react";
import React from "react";
import { Backdrop, Dialog, DialogActions, DialogTitle, Fade, IconButton, MenuItem, Modal, TextField, makeStyles, styled } from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';


const MyCustomNotification = forwardRef((props: any, ref: any) => {

    
const [dialogTitle, setDialogTitle] = useState("");
const [dialogDesc, setDialogDesc] = useState("");


  useImperativeHandle(ref, () => ({
    log() {
      console.log("child function");
    }
  }));


  const [openDlg, setDlgOpen] = useState(true);

  const handleDlgClose = () => {
    
    setDlgOpen(false);
    props.onClose()
};

let iscalled = false;

useEffect(() => {


    //console.log("+++++++++++++++selectedBradId : " + props.title)
    if (!iscalled) {
      iscalled = true

      if (props!=null && props.title!=null && props.message!=null) {
        setDialogDesc(props. message )
        setDialogTitle(props.title)  
      }
  
    }
  }, []);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 , fontSize: 18  }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}


///


  return (
    <div >

<BootstrapDialog
                    onClose={handleDlgClose}
                    aria-labelledby="customized-dialog-title"
                    open={openDlg}>

                    <BootstrapDialogTitle id="customized-dialog-title" onClose={handleDlgClose}>
                    {dialogTitle}
                    </BootstrapDialogTitle>

                   {/*<div className="m-2 pr-4 pl-2 pt-2"><p>File name should contain characters [a-z] , [A-Z] , [0-9] or Underscore [ _ ] </p> </div> */ }

                   <div className="m-2 pr-4 pl-2 pt-2"><p>{dialogDesc} </p> </div>

                    <DialogActions>
                   
                    </DialogActions>
                </BootstrapDialog>


    </div>
  );
})

export default MyCustomNotification;
